export const CRM_HOME = "/crm";

export function crmReturnTo(value) {
  try {
    const target = new URL(value || CRM_HOME, window.location.origin);
    if (target.origin !== window.location.origin) return CRM_HOME;
    const path = target.pathname.replace(/\/+$/, "") || "/";
    const destination = ["/", "/login", "/dashboard"].includes(path)
      ? CRM_HOME
      : target.pathname;
    return `${destination}${target.search}${target.hash}`;
  } catch {
    return CRM_HOME;
  }
}
